/**
 * UpgradePrompt Store (Zustand)
 *
 * Global, single-instance state for the <UpgradePromptModal>. Any component
 * can trigger a prompt via `useUpgradePromptStore.getState().open(gateKey)`.
 *
 * Used by:
 * - `useUpgradeGate` hook (pre-emptive UX at the click site)
 * - API service 402 interceptor (server-side denials)
 */

import { create } from 'zustand';
import type { GateKey, GateContext } from '@bower/shared';

interface UpgradePromptState {
  gateKey: GateKey | null;
  context: GateContext;
  open: (gateKey: GateKey, context?: GateContext) => void;
  close: () => void;
}

export const useUpgradePromptStore = create<UpgradePromptState>((set) => ({
  gateKey: null,
  context: {},
  open: (gateKey, context = {}) => set({ gateKey, context }),
  close: () => set({ gateKey: null, context: {} }),
}));
